import * as React from 'react';

import classNames from 'classnames';
import type Maybe from 'graphql/tsutils/Maybe';

import { Grid, PageGridContainer } from '@coursera/cds-core';
import { StyleSheet, color, css } from '@coursera/coursera-ui';

import Markdown from 'bundles/cms/components/Markdown';
import TestimonialCarousel from 'bundles/design-system/components/TestimonialCarousel';
import { getLOHPTestimonialsHeader, getSocialProofs } from 'bundles/front-page/constants/defaults';
import { sourceSansPro, stylusBreakpoints } from 'bundles/front-page/constants/rebrand';

import 'css!../__styles__/SocialProofContainer';

const styles = StyleSheet.create({
  socialProofContainer: {
    display: 'block',
    marginTop: '100px',
    position: 'relative',
    width: '100%',
  },
  text: {
    margin: '0 auto 50px',
    maxWidth: '800px',
    textAlign: 'center',
    width: '100%',
  },
  title: {
    fontWeight: 600,
    fontFamily: sourceSansPro,
    color: color.primaryText,
    fontSize: '44px',
    lineHeight: '52px',
    margin: '0 20px 14px',
    [stylusBreakpoints.tabletOrSmaller]: {
      fontSize: '36px',
      lineHeight: '48px',
    },
    [stylusBreakpoints.phoneOrSmaller]: {
      fontSize: '28px',
      lineHeight: '36px',
    },
  },
  subtitle: {
    color: color.primaryText,
    fontSize: '28px',
    lineHeight: '36px',
    [stylusBreakpoints.tabletOrSmaller]: {
      fontSize: '28px',
      lineHeight: '36px',
    },
    [stylusBreakpoints.phoneOrSmaller]: {
      fontSize: '16px',
      lineHeight: '21px',
    },
  },
  socialProofTitle: {
    fontSize: '28px',
    lineHeight: '36px',
  },
});

type PropsToComponent = { title?: Maybe<string> };

const SocialProofContainerRedesign: React.FC<PropsToComponent> = ({ title }) => {
  const socialProofs = getSocialProofs();
  const containerClassnames = classNames(css(styles.socialProofContainer).className, 'rc-SocialProofContainerRedesign');

  return (
    <section className={containerClassnames}>
      <PageGridContainer>
        <Grid item xs={12}>
          {title ? (
            <div {...css(styles.text)}>
              <Markdown source={title} />
            </div>
          ) : (
            <div {...css(styles.text)}>
              <h2 {...css(styles.title)}>{getLOHPTestimonialsHeader().title}</h2>
              <p {...css(styles.subtitle)}>{getLOHPTestimonialsHeader().subtitle}</p>
            </div>
          )}
          <div className="carousel-container">
            <TestimonialCarousel socialProofItems={socialProofs} />
          </div>
        </Grid>
      </PageGridContainer>
    </section>
  );
};

export default SocialProofContainerRedesign;
